<template>
  <div class="date-picker-row">
    <template v-for="(monthName, month) in monthList">
      <div
        :key="`date-picker-month-${month}`"
        class="date-picker-cell"
      >
        <div
          :class="getClass(month)"
          @click="e => handleMonthClick(e, { month, year: pickerYear })"
        >
          {{ monthName }}
        </div>
      </div>
      <div
        v-if="(month + 1) % 4 === 0"
        :key="`date-picker-month-break-${(month + 1) / 4}`"
        class="date-picker-break"
      />
    </template>
    <div
      class="date-picker-shortcut-button"
      @click="setThisMonth"
    >
      {{ getShortcutCopy('month') }}
    </div>
  </div>
</template>

<script>
import DatePickerMixins from '../mixins';
import locale from '../locale';

export default {
  name: 'MDatepickerMonthPicker',
  mixins: [
    DatePickerMixins,
  ],
  props: {
    pickerMonth: {
      type: Number,
      default: 0,
    },
    pickerYear: {
      type: Number,
      default: 2020,
    },
    selectedMonth: {
      type: Number,
      default: 0,
    },
    selectedYear: {
      type: Number,
      default: 2020,
    },
    language: {
      type: String,
      default: 'en',
    },
    disabledDates: {
      type: Object,
      default: null,
    },
  },
  computed: {
    monthList() {
      return locale.dictionary[this.language].shortMonths;
    },
  },
  methods: {
    setThisMonth() {
      const date = new Date();
      const params = {
        month: date.getMonth(),
        year: date.getFullYear(),
        from: 'monthPicker',
      };
      this.$emit('update-selected-date', { ...params });
    },
    handleMonthClick(event, { month, year }) {
      const classes = event.target.className;

      // emit date change event only if it's not disabled
      if (!classes.includes('disabled')) this.$emit('update-selected-date', { month, year, from: 'monthPicker' });
    },
    getClass(month) {
      const today = new Date();
      const isToday = month === today.getMonth() && today.getFullYear() === this.pickerYear;
      const isSelectedMonth = month === this.selectedMonth && this.pickerYear === this.selectedYear;

      return {
        'date-picker-month-cell': true,
        'current-month': isToday,
        'selected-month': isSelectedMonth,
        'disabled-month': this.isDisabledMonth(month),
      };
    },
    isDisabledMonth(currentMonth) {
      let disabledMonth = false;

      if (!this.disabledDates) return false;

      if (this.disabledDates.to) {
        const toDate = new Date(this.disabledDates.to);
        
        if (this.pickerYear < toDate.getFullYear() ||
        (currentMonth < toDate.getMonth() && this.pickerYear === toDate.getFullYear())) disabledMonth = true;
      }

      if (this.disabledDates.from) {
        const fromDate = new Date(this.disabledDates.from);
        
        if (this.pickerYear > fromDate.getFullYear() ||
        (currentMonth > fromDate.getMonth() && this.pickerYear === fromDate.getFullYear())) disabledMonth = true;
      }

      return disabledMonth;
    },
  },
};
</script>
